<template>
  <div>
    <img src="../assets/mobile/map.png" class="map1" @click="mapFlag = true" />

    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="map" v-if="mapFlag">
        <img src="../assets/mobile/close.png" class="close" @click="mapFlag = false" />
        <div class="img">
          <div class="zhanting" @click="value1 = 1">
            <img src="../assets/topImg/汽车展厅亮.png" class="img1" v-if="value1 == 0" />
            <img src="../assets/topImg/汽车展厅亮暗.png" class="img1" v-else />
          </div>

          <div class="bgt" @click="value1 = 0">
            <img src="../assets/topImg/报告厅亮.png" class="img1" v-if="value1 == 1" />
            <img src="../assets/topImg/报告厅暗.png" class="img1" v-else />
          </div>

          <div class="gr" @click="value1 = 2">
            <img src="../assets/topImg/个人空间亮.png" class="img1" v-if="value1 == 2" />
            <img src="../assets/topImg/个人空间暗.png" class="img1" v-else />
          </div>

          <div class="gm" @click="value1 = 3">
            <img src="../assets/topImg/游戏亮.png" class="img1" v-if="value1 == 3" />
            <img src="../assets/topImg/游戏暗.png" class="img1" v-else />
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="box" v-if="value1 != -1">
        <div class="title">
          <p>{{ list[value1].title }}</p>
          <div class="close" @click="value1 = -1"></div>
        </div>

        <img :src="list[value1].img" class="ditu" />

        <p class="intro">{{ list[value1].intro }}</p>

        <img src="../assets/topImg/btn.png" class="btn" @click="to" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mapFlag: false,
      value1: -1,
      list: [
        {
          title: "BMW Exhibition Center",
          intro: "Auto show, 4S automobile store… ",
          img: require("../assets/topImg/地图1.png"),
          url: "../carroom111/#/index",
        },

        {
          title: "BMW Convention Center",
          intro: "New car launch event, Brand party, Large-scale internal training…",
          img: require("../assets/topImg/地图2.png"),
          url: "../room111/#/index",
        },
        {
          title: "Bimmer Home",
          intro: "Bimmer customized space, Personal collection exhibition…",
          img: require("../assets/topImg/地图3.png"),
          url: "../personalspace/",
        },

        {
          title: "BMW Game Park",
          intro: "AR car racing game…",
          img: require("../assets/topImg/地图4.png"),
          url: "http://122.200.93.30:33020/downloadApp.html",
        },
      ],
    };
  },

  methods: {
    to() {
      window.location.href = this.list[this.value1].url;
    },
  },
};
</script>

<style style lang="scss" scoped>
.box {
  width: 610px;
  height: 374px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: url("../assets/topImg/弹窗.png");
  background-size: 100% 100%;
  transform: scale(0.6);
  z-index: 2;
  .title {
    margin-left: 11px;
    margin-top: 11px;
    width: 586px;
    height: 50px;
    background: url("../assets/topImg/title.png");
    background-size: 100% 100%;
    position: relative;
    p {
      font-size: 20px;
      font-family: Impact, Impact-Regular;
      font-weight: 400;
      margin-left: 20px;
      color: white;
      width: 200px;
      text-align: left;
      line-height: 50px;
    }

    .close {
      width: 40px;
      height: 40px;
      position: absolute;
      position: absolute;
      top: 4px;
      right: 10px;
      cursor: pointer;
    }
  }
  .ditu {
    width: 273px;
    height: 288px;
    position: absolute;
    left: 20px;
    bottom: 20px;
  }

  .intro {
    width: 252.09px;
    height: 128.04px;
    font-size: 2;
    font-family: BMW Group, BMW Group-Regular;
    font-weight: 400;
    text-align: left;
    color: #58729a;
    line-height: 23.34px;
    letter-spacing: 0.57px;
    position: absolute;
    top: 86px;
    right: 38px;
  }

  .btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
  }
}
.map {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;

  background: rgba($color: #fff, $alpha: 1);
  font-size: 12px;
  font-family: BMW Group, BMW Group-Bold;
  font-weight: bold;
  color: #536b8e;
  z-index: 1;
  .img {
    width: 650px;
    height: 350px;
    // height: 561px;
    background: url("../assets/topImg/bg.jpg");
    background-size: 100% 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    position: absolute;

    // transform: scale(0.8);
  }
  .zhanting {
    width: 230px;

    position: absolute;
    left: 6%;
    top: 25%;
    z-index: 1;
    cursor: pointer;

    .img1 {
      width: 100%;
      transition: 0.5s;
    }

    .font1 {
      left: 57px;
      top: 33px;
    }
  }
  .font {
    position: absolute;

    transform: scale(0.7);
  }

  .bgt {
    width: 230px;
    position: absolute;
    left: 40%;
    top: 28%;
    z-index: 1;
    cursor: pointer;

    .img1 {
      width: 100%;
      transition: 0.5s;
    }

    .font2 {
      left: 52px;
      top: 26px;
    }
  }

  .gr {
    width: 230px;
    position: absolute;
    right: -6%;
    top: 10%;
    z-index: 1;
    cursor: pointer;

    .img1 {
      width: 100%;
      transition: 0.5s;
    }

    .font2 {
      left: 75px;
      top: 28px;
    }
  }

  .gm {
    width: 230px;
    position: absolute;
    right: 21%;
    top: 1%;
    z-index: 1;
    cursor: pointer;

    .img1 {
      width: 100%;
      transition: 0.5s;
    }

    .font2 {
      left: 57px;
      top: 20px;
    }
  }
}

.map1 {
  position: fixed;
  left: 30px;
  top: 20px;
  width: 80px;
}

.close {
  position: fixed;
  top: 20px;
  right: 14px;
  z-index: 3;
}
</style>
